import React from "react";
const TextIcon = (props) => {
  const { default_color } = props;
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      height="16"
      width="16"
    //   class="attribute-data-type-icon ic-icon-2 ic-icon-2-small ic-text-letter-icon"
    >
      <path d="M5 5v2h4v8h2V7h4V5H5z" fill="currentColor"></path>
    </svg>

    // </div>
  );
};
export default TextIcon;
